import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { SmeCarousel as Component } from '../sme-carousel';
import { SmeCarouselDots as Dots } from '../components/dots';
import type { IDepsDesktop, TSmeCarouselDesktop } from '../models';
import { ArrowDesktop as Arrow } from '../components/arrows/arrow/desktop';
import { FullHeightArrowDesktop } from '../components/arrows/full-height-arrow/desktop';

import styles from './desktop.css';

export const SmeCarouselDesktop = createWidget<IDepsDesktop, TSmeCarouselDesktop>({
    Dots,
    Arrow,
    styles,
    isMobile: false,
    FullHeightArrow: FullHeightArrowDesktop,
})(Component);
